/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DefinitionNameLabel } from './DefinitionNameLabel';
import {
    instanceOfDefinitionNameLabel,
    DefinitionNameLabelFromJSON,
    DefinitionNameLabelFromJSONTyped,
    DefinitionNameLabelToJSON,
} from './DefinitionNameLabel';

/**
 * @type CreateDefinitionDtoDefinitionLabel
 * 
 * @export
 */
export type CreateDefinitionDtoDefinitionLabel = DefinitionNameLabel;


export function CreateDefinitionDtoDefinitionLabelFromJSON(json: any): CreateDefinitionDtoDefinitionLabel {
    return CreateDefinitionDtoDefinitionLabelFromJSONTyped(json, false);
}

export function CreateDefinitionDtoDefinitionLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDefinitionDtoDefinitionLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...DefinitionNameLabelFromJSONTyped(json, true) };
    return  DefinitionNameLabelFromJSONTyped(json, true);
}

export function CreateDefinitionDtoDefinitionLabelToJSON(value?: CreateDefinitionDtoDefinitionLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfDefinitionNameLabel(value)) {
        return DefinitionNameLabelToJSON(value as DefinitionNameLabel);
    }

    return {};
}

/**
 * Check if a given object implements the CreateDefinitionDtoDefinitionLabel interface.
 */
export function instanceOfCreateDefinitionDtoDefinitionLabel(value: any): value is CreateDefinitionDtoDefinitionLabel {
    if (instanceOfDefinitionNameLabel(value)) return true;
    return false;
}

